export default {
    id: "product_names",
    endpoint: `${process.env.NX_FINANCIAL_OPERATION_API_URL}/product.name/aggregated`,
    withSelectedAccounts: true,
};
